import React from "react";

const DeleteVoitures = () => {
  return <div>Edit Voiture</div>;
};

export { DeleteVoitures };
